/*
  Project: Wholegrain Milling
  Author: Marcin Ziółek
 */

import 'picturefill';
import initSite from './modules/init-site';
import sliders from './modules/sliders';
import navigation from './modules/navigation';
import customScroll from './modules/custom-scrollbar';
import modal from './modules/modal';
import ourStory from './modules/our-story';
import product from './modules/product';
import video from './modules/video';
import blog from './modules/blog';
import faq from './modules/faq';
import contact from './modules/contact';
import ourMill from './modules/our-mill';
import splitSection from './modules/split-section';

initSite();
sliders();
navigation();
customScroll();
modal();
ourStory();
product();
video();
blog();
faq();
contact();
ourMill();
splitSection();



// WEBPACK FOOTER //
// ./src/scripts/app.js